import { motion, useMotionValue, useMotionTemplate } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const LINES = [
  { t: "Un laboratorio", cls: "" },
  { t: "che allena", cls: "text-outline" },
  { t: "lo stile", cls: "" },
  { t: "di vita.", cls: "text-[#c4dcca]" },
];
const DAYS = ["LUN", "MAR", "MER", "GIO", "VEN", "SAB", "DOM"];
const ease = [0.22, 1, 0.36, 1];

export const Hero = () => {
  const today = (new Date().getDay() + 6) % 7;
  const mx = useMotionValue(70);
  const my = useMotionValue(30);
  const glow = useMotionTemplate`radial-gradient(600px circle at ${mx}% ${my}%, rgba(152,191,162,0.16), transparent 60%)`;
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set(((e.clientX - r.left) / r.width) * 100);
    my.set(((e.clientY - r.top) / r.height) * 100);
  };
  return (
    <section data-testid="hero-section" onMouseMove={onMove} className="relative overflow-hidden px-5 pb-16 pt-28 md:px-10 md:pt-36">
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(152,191,162,0.06)_1px,transparent_1px),linear-gradient(90deg,rgba(152,191,162,0.06)_1px,transparent_1px)] bg-[size:calc(100%/7)_120px]" />
      <motion.div className="pointer-events-none absolute inset-0" style={{ background: glow }} />
      <div className="relative mx-auto max-w-[1400px]">
        <div>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} className="eyebrow mb-6">
            Hybrid Health Lab · Lifestyle Training
          </motion.p>
          <h1 data-testid="hero-title" className="font-display text-[15vw] font-900 uppercase leading-[0.84] tracking-tight sm:text-[12vw] lg:text-[9.5vw] 2xl:text-[150px]">
            {LINES.map((l, i) => (
              <span key={l.t} className="block overflow-hidden pb-1">
                <motion.span className={`block ${l.cls}`} initial={{ y: "110%", rotate: 4 }} animate={{ y: "0%", rotate: 0 }}
                  transition={{ duration: 1.1, delay: 0.15 + i * 0.11, ease }}>
                  {l.t}
                </motion.span>
              </span>
            ))}
          </h1>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.8, ease }}
            className="mt-12">
            <p className="max-w-2xl text-base text-[#a3b1aa] md:text-lg">
              Sai già cosa dovresti fare: allenarti, mangiare meglio, recuperare. Il punto è riuscirci ogni giorno, anche quando la settimana ti travolge. A fare la differenza sono le competenze che nessuno ti ha mai insegnato: valori, organizzazione e gestione delle emozioni. Quanto sono allenate le tue?
            </p>
            <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6">
              <Link to="/test-soft-skills" data-testid="hero-checkup-btn"
                className="group inline-flex items-center justify-center gap-3 bg-[#c4dcca] px-8 py-5 font-display text-xl font-900 uppercase tracking-tight text-[#0b0f0d] transition-colors hover:bg-[#f4f7f5] md:text-2xl">
                Fai il check-up gratuito
                <ArrowRight size={24} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <p data-testid="hero-checkup-note" className="font-mono text-xs uppercase tracking-widest text-[#a3b1aa]">
                Soft Skills · 27 domande · 5 minuti
              </p>
            </div>
          </motion.div>
        </div>
      </div>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.2, duration: 1 }}
        className="relative mx-auto mt-16 grid max-w-[1400px] grid-cols-7 border-t border-[rgba(152,191,162,0.2)]" data-testid="hero-day-ticker">
        {DAYS.map((d, i) => (
          <div key={d} className={`pt-3 font-mono text-[11px] tracking-widest md:text-xs ${i === today ? "text-[#c4dcca]" : "text-[#a3b1aa]"}`}>
            {i === today && <span className="mr-1 inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-[#c4dcca] align-middle" />}
            {d}
          </div>
        ))}
      </motion.div>
    </section>
  );
};
